import UploadButton from './scripts';
import './styles/uploadButton.scss';

UploadButton.init();
